import {
    Checkbox,
    Table,
    TableBody,
    TableHead,
    TableRow,
    Typography,
    TableCell,
    styled,
} from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormCheckbox from '../../shared/FormCheckbox';

const StyledTableCell = styled(TableCell)({
    paddingLeft: 0,
    paddingRight: 0,
});

const ExperienceNotifications = () => {
    const { control } = useFormContext();
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <StyledTableCell
                        sx={{ width: '70%', borderBottom: 'none', py: 0 }}
                    >
                        <Typography variant='subHeading'>
                            Experience Notifications
                        </Typography>
                    </StyledTableCell>
                    <StyledTableCell
                        padding='checkbox'
                        align='center'
                        sx={{ borderBottom: 'none' }}
                    >
                        Email
                    </StyledTableCell>
                    <StyledTableCell
                        padding='checkbox'
                        align='center'
                        sx={{ borderBottom: 'none' }}
                    >
                        Mobile
                    </StyledTableCell>
                    <StyledTableCell
                        padding='checkbox'
                        align='center'
                        sx={{ borderBottom: 'none' }}
                    >
                        In-app
                    </StyledTableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                <TableRow>
                    <StyledTableCell>
                        <Typography>Promotions & Discounts</Typography>
                        Get notified when new discounts or special offers become
                        available.
                    </StyledTableCell>
                    <StyledTableCell padding='checkbox' align='center'>
                        <FormCheckbox
                            name='discountEmailNotification'
                            control={control}
                        />
                    </StyledTableCell>
                    <StyledTableCell padding='checkbox' align='center'>
                        N/A
                    </StyledTableCell>
                    <StyledTableCell padding='checkbox' align='center'>
                        N/A
                    </StyledTableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

export default ExperienceNotifications;
